export enum MyTicketsViewType {
  Assigned = 1,
  Reported = 2,
  All = 3,
}
